// package dependencies
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';
// project dependencies
import Address from '../../../common/ui/Address';
import { PrefixToLabel } from '../GuestListTypes';
import { isCompleteAddress, isMissingAddress, isNameUnknown } from '../util';

class GuestGroupRow extends Component {
  constructor(props) {
    super(props);

    this.rowCheck = this.rowCheck.bind(this);
    this.rowClick = this.rowClick.bind(this);
    this.toggleInvited = this.toggleInvited.bind(this);

    this.state = {
      active: false,
      timeout: null,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { modalOpen, onSelectGuestGroup } = this.props;
    if (modalOpen && (nextProps.modalOpen === false)) {
      this.setState({
        timeout: setTimeout(() => onSelectGuestGroup(null), 1000)
      });
    }
  }

  componentWillUnmount() {
    const { timeout } = this.state;
    if (timeout) {
      clearTimeout(timeout);
    }
  }

  rowCheck() {
    const { guestGroup, onRowCheck, isRowChecked } = this.props;
    onRowCheck(guestGroup.id, !isRowChecked);
  }

  rowClick(e) {
    const { guestGroup, onEditGuestGroup, onSelectGuestGroup } = this.props;
    if (e.target.hasAttribute('data-no-edit')) {
      e.stopPropagation();
      e.nativeEvent.stopImmediatePropagation();
    } else {
      onEditGuestGroup(guestGroup.id);
      onSelectGuestGroup(guestGroup.id);
    }
  }

  toggleInvited(invited) {
    const { guestGroup, onToggleInvited } = this.props;
    const eventInvitations = _.flatMap(guestGroup.guests, guest => guest.event_invitations);
    const hasResponses = eventInvitations.some(eventInvitation => eventInvitation.rsvp_at !== null);
    onToggleInvited([guestGroup.id], invited, hasResponses);
  }

  render() {
    const {
      wedding,
      guestGroup,
      onDeleteGuestGroups,
      onSelectGuestGroup,
      onGuestMessage,
      onRequestMissingInfo,
      isRowChecked,
      isActive
    } = this.props;

    if (!guestGroup || !guestGroup.guests) return null;

    const [primaryGuests, otherGuests] = _.partition(guestGroup.guests, guest => guest.relationship_type === 'PRIMARY');
    const primaryGuest = primaryGuests[0] || otherGuests[0];

    const address = {
      address1: guestGroup.address_1,
      address2: guestGroup.address_2,
      city: guestGroup.city,
      state: guestGroup.state_province,
      zip: guestGroup.postal_code,
      countryCode: guestGroup.country_code
    };

    const GUEST_AFFILIATION = {
      UNKNOWN: '',
      PRIMARY_FAMILY: 'Primary\'s Family',
      PRIMARY_WEDDING_PARTY: 'Primary\'s Wedding Party',
      PRIMARY_FRIEND: 'Primary\'s Friend',
      PRIMARY_FAMILY_FRIEND: 'Primary\'s Family Friend',
      PARTNER_FAMILY: 'Partner\'s Family',
      PARTNER_WEDDING_PARTY: 'Partner\'s Wedding Party',
      PARTNER_FRIEND: 'Partner\'s Friend',
      PARTNER_FAMILY_FRIEND: 'Partner\'s Family Friend',
      BOTH: 'Primary and Partner\'s Friend',
    };

    const injectCoupleNames = (primaryName, partnerName) => (
      affiliation => affiliation.replace('Primary\'s', `${primaryName}'s`).replace('Primary', primaryName).replace('Partner\'s', `${partnerName}'s`)
    );

    const relationshipToCouple = injectCoupleNames(wedding.owner_first_name, wedding.partner_first_name);
    // recaptcha changeover
    return (
      <tr className={isActive ? 'table-row table-row-active' : 'table-row'} onClick={this.rowClick} onMouseEnter={() => onSelectGuestGroup(guestGroup.id)}>
        <td className="td-checkbox">
          <div className="checkbox checkbox-table checkbox-secondary">
            <label htmlFor={`guests-${guestGroup.id}`}>
              <input
                type="checkbox"
                id={`guests-${guestGroup.id}`}
                data-no-edit
                checked={isRowChecked}
                onChange={this.rowCheck}
              />
              <span className="input-override" data-no-edit><i className="zolaicon zolaicon-checkmark" data-no-edit /></span>
            </label>
          </div>
        </td>
        <td className="guest-group-list">
          <div className="primary-guest-name">{PrefixToLabel[primaryGuest.prefix]} {primaryGuest.first_name} <strong>{primaryGuest.family_name}</strong></div>
          <ul className="list-indent">
            {otherGuests.length > 0 && otherGuests.map(otherGuest => (
              <li key={otherGuest.id}>
                {isNameUnknown(otherGuest) ? (
                  <span>{(otherGuest.relationship_type === 'CHILD') ? 'Child' : 'Guest'}</span>
                ) : (
                  <span>{PrefixToLabel[otherGuest.prefix]} {otherGuest.first_name} {otherGuest.family_name}</span>
                )}
              </li>
            ))}
            <li className="relationship-type text-muted">{relationshipToCouple(GUEST_AFFILIATION[guestGroup.affiliation])}</li>
          </ul>
        </td>
        <td>{guestGroup.guests.length}</td>
        <td className="contact-info">
          {guestGroup.email_address ? (
            <div>{guestGroup.email_address}</div>
          ) : (
            <div className="text-muted">No Email</div>
          )}
          {guestGroup.mobile_phone ? (
            <div>{guestGroup.mobile_phone}</div>
          ) : (
            <div className="text-muted">No Mobile</div>
          )}
        </td>
        <td className="mailing-address">
          {isCompleteAddress(address) ? (
            <Address {...address} />
          ) : (
            <div className="incomplete-mailing-address">
              <div className="text-danger">{isMissingAddress(address) ? 'Missing Address' : 'Incomplete Address'}</div>
              {guestGroup.email_address && (
                <div className="request-missing-info">
                  <div className="with-tooltip no-tooltip-on-mobile" data-tooltip="Missing a guest's address or contact information? We'll help you collect it.">
                    <button className="btn-link btn-link-cta" data-no-edit onClick={() => onRequestMissingInfo([guestGroup.id])}>Request Missing Info›</button>
                  </div>
                  {(guestGroup.collect_addresses_message_sent_at && guestGroup.collect_address_copied_at) && (
                    <div>
                      {moment(guestGroup.collect_addresses_message_sent_at).isAfter(moment(guestGroup.collect_address_copied_at)) ? (
                        <i className="text-muted">Sent Request {moment.utc(guestGroup.collect_addresses_message_sent_at).format('MM/DD/YY')}</i>
                      ) : (
                        <i className="text-muted">Copied Link {moment.utc(guestGroup.collect_address_copied_at).format('MM/DD/YY')}</i>
                      )}
                    </div>
                  )}
                  {(guestGroup.collect_addresses_message_sent_at && !guestGroup.collect_address_copied_at) && (
                    <div>
                      <i className="text-muted">Sent Request {moment.utc(guestGroup.collect_addresses_message_sent_at).format('MM/DD/YY')}</i>
                    </div>
                  )}
                  {(!guestGroup.collect_addresses_message_sent_at && guestGroup.collect_address_copied_at) && (
                    <div>
                      <i className="text-muted">Copied Link {moment.utc(guestGroup.collect_address_copied_at).format('MM/DD/YY')}</i>
                    </div>
                  )}
                </div>
              )}
              {!guestGroup.email_address && (
                <div className="request-missing-info">
                  <div className="with-tooltip no-tooltip-on-mobile" data-tooltip="Missing a guest's address or contact information? We'll help you collect it.">
                    <button className="btn-link btn-link-cta" data-no-edit onClick={() => onRequestMissingInfo([guestGroup.id])}>Request Missing Info›</button>
                  </div>
                  <div>
                    {guestGroup.collect_address_copied_at && (
                      <i className="text-muted">Copied Link {moment.utc(guestGroup.collect_address_copied_at).format('MM/DD/YY')}</i>
                    )}
                  </div>
                </div>
              )}
            </div>
          )}
        </td>
        <td className="guestlist-radio">
          <label className="radio-inline guestlist-radio" htmlFor={`${guestGroup.id}-invited-yes`} data-no-edit>
            <input
              type="radio"
              id={`${guestGroup.id}-invited-yes`}
              checked={guestGroup.invited}
              onChange={() => this.toggleInvited(true)}
              data-no-edit
            />
            <span className="input-override" data-no-edit />
            Definitely
          </label>
          <label className="radio-inline guestlist-radio" htmlFor={`${guestGroup.id}-invited-no`} data-no-edit>
            <input
              type="radio"
              id={`${guestGroup.id}-invited-no`}
              checked={!guestGroup.invited}
              onChange={() => this.toggleInvited(false)}
              data-no-edit
            />
            <span className="input-override" data-no-edit />
            Maybe
          </label>
        </td>
        <td>
          {guestGroup.email_address ? (
            <span className="margin-right with-tooltip" data-tooltip="Send a message">
              <button className="btn btn-icon" onClick={() => onGuestMessage([guestGroup.id])} data-no-edit>
                <i style={{ fontSize: '25px' }} className="zolaicon zolaicon-email" data-no-edit />
              </button>
            </span>
          ) : (
            <span className="margin-right with-tooltip" data-tooltip="Add guest's email to send a message">
              <button className="btn btn-icon btn-disabled" data-no-edit>
                <i style={{ fontSize: '25px' }} className="zolaicon zolaicon-email" data-no-edit />
              </button>
            </span>
          )}
          <span className="margin-left with-tooltip" data-tooltip="Delete guest">
            <button className="btn btn-icon" onClick={() => onDeleteGuestGroups([guestGroup.id])} data-no-edit>
              <i className="glyphicon glyphicon-trash" data-no-edit />
            </button>
          </span>
        </td>
      </tr>
    );
  }
}

GuestGroupRow.propTypes = {
  guestGroup: PropTypes.shape({}),
  onToggleInvited: PropTypes.func.isRequired,
  onEditGuestGroup: PropTypes.func.isRequired,
  onDeleteGuestGroups: PropTypes.func.isRequired,
  wedding: PropTypes.shape({
    owner_first_name: PropTypes.string,
    partner_first_name: PropTypes.string,
  }),
  onGuestMessage: PropTypes.func.isRequired,
  onRowCheck: PropTypes.func.isRequired,
  isRowChecked: PropTypes.bool.isRequired,
  onSelectGuestGroup: PropTypes.func.isRequired,
  modalOpen: PropTypes.bool,
  isActive: PropTypes.bool,
  onRequestMissingInfo: PropTypes.func,
};

export default GuestGroupRow;



// WEBPACK FOOTER //
// ./src/components/manage/guestlist/directoryEntities/GuestGroupRow.jsx